import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { QuestionSectionWrapper } from "../../../../../_shared/ui/components/system/question/_layouts/item-wrapper";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	capacityPeopleMaximum: ForNodeType<number>;
	onSetCapacityPeopleMaximum: (input: number | undefined) => void; //
	capacityAdultMaximum: ForNodeType<number>;
	onSetCapacityAdultMaximum: (input: number | undefined) => void;
	capacityKidsMaximum: ForNodeType<number>;
	onSetCapacityKidsMaximum: (input: number | undefined) => void;
	isKidsUnavailable: ForNodeType<boolean>;
	onSetIsKidsUnavailable: (input: boolean) => void;

	title?: string;
	guide?: string;
};

export const QuestionRoomCapacity = ({
	isEdited,
	hasError,
	capacityPeopleMaximum,
	onSetCapacityPeopleMaximum, //
	capacityAdultMaximum,
	onSetCapacityAdultMaximum,
	capacityKidsMaximum,
	onSetCapacityKidsMaximum,
	isKidsUnavailable,
	onSetIsKidsUnavailable,

	guide: _guide,
	title: _title,
}: Props) => {
	const isKidsUnavailableFieldLabel = "子供の利用が不可能な部屋にする";

	const title = _title || "部屋の定員";
	const guide =
		_guide ||
		`ベッドや布団を通常利用した時の。部屋の定員を入力してください。
    子供の利用が 不可能 な場合、定員 = 大人の定員 となります。
    子供の利用が 可能 な場合、それぞれに希望する定員を設定しましょう。<br /><br />
    ・大人のみ<br />
    ・設定した定員に満たない組み合わせ<br />
    ・子供が添い寝する<br /><br />
    などの様々なパターンでの宿泊が可能なため、<br />
    大人と子供の定員の合計が、部屋の定員となる必要はありません。<br />
    予約されるゲストの大人と子供の人数の合計が定員以下の場合に予約可能になります。`;

	return (
		<FeatureIslandCategoryQuestionForMain
			required
			isEdited={isEdited}
			hasError={hasError}
			title={title}
			guide={guide}
			inputChildren={
				<div className="space-y-4">
					<QuestionSectionWrapper>
						<p className="w-20">定員：</p>
						<InputNumberField
							value={capacityPeopleMaximum.value}
							errorMessage={capacityPeopleMaximum.error}
							handleInput={onSetCapacityPeopleMaximum}
							hiddenSpinButton={false}
						/>
						<p>人</p>
					</QuestionSectionWrapper>

					{!isKidsUnavailable.value && (
						<QuestionSectionWrapper>
							<p className="w-20">大人：</p>
							<InputNumberField
								value={capacityAdultMaximum.value}
								errorMessage={capacityAdultMaximum.error}
								handleInput={onSetCapacityAdultMaximum}
								hiddenSpinButton={false}
							/>
							<p>人</p>
						</QuestionSectionWrapper>
					)}

					<div className="flex flex-col gap-y-6">
						{!isKidsUnavailable.value && (
							<QuestionSectionWrapper>
								<p className="w-20">子ども：</p>
								<InputNumberField
									value={capacityKidsMaximum.value}
									errorMessage={capacityKidsMaximum.error}
									handleInput={onSetCapacityKidsMaximum}
									hiddenSpinButton={false}
								/>
								<p>人</p>
							</QuestionSectionWrapper>
						)}

						<div className="flex flex-col gap-y-6">
							<p className="text-xs">キッズポリシーを適応できる子供の人数上限を入力してください。</p>

							<div className="flex flex-row items-center space-x-3 space-y-0">
								<div>
									<CheckboxField
										label={isKidsUnavailableFieldLabel}
										value={isKidsUnavailable.value}
										errorMessage={isKidsUnavailable.error}
										handleChange={onSetIsKidsUnavailable}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			}
		/>
	);
};

QuestionRoomCapacity.displayName = "QuestionRoomCapacity";
